import { SvgComponentProps, Svg } from './svg-component';
export const AlertTriangleIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 48} height={size || 48} viewBox="0 0 16 16" fill="none" {...rest}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 .007a1.71 1.71 0 0 0-1.526.932h0l-.002.005-6.285 12.57v.001A1.714 1.714 0 0 0 1.712 16h12.574a1.715 1.715 0 0 0 1.527-2.485h0L9.527.944h0L9.526.938A1.71 1.71 0 0 0 8 .007ZM8 5c.394 0 .714.32.714.714v3.429a.714.714 0 0 1-1.428 0V5.715c0-.394.32-.714.714-.714Zm0 8.714a1.143 1.143 0 1 0 0-2.285 1.143 1.143 0 0 0 0 2.285Z"
            fill="currentColor"
        />
    </Svg>
);
